
/* BARE & GEMS — MINIMAL ROTATING OFFERS */

(() => {
  const SELECTOR = '.bg-rotating-offers';
  const ITEM = '.bg-rotating-offer';
  const COLORS = ['#24734C', '#4B2E24'];
  const INTERVAL = 3200;
  const DURATION = 650;

  function init() {
    document.querySelectorAll(SELECTOR).forEach(container => {
      if (container.dataset.bgOffersReady === 'true') return;

      const offers = [...container.querySelectorAll(ITEM)];
      if (!offers.length) return;

      container.dataset.bgOffersReady = 'true';

      container.style.setProperty('position', 'relative', 'important');
      container.style.setProperty('height', '24px', 'important');
      container.style.setProperty('overflow', 'hidden', 'important');
      container.style.setProperty('margin', '5px 0 2px', 'important');

      offers.forEach((offer, index) => {
        const label = offer.querySelector('.bg-diamond-text');

        if (label) {
          offer.textContent = label.textContent.trim();
        }

        offer.className = 'bg-rotating-offer';

        offer.style.setProperty('display', 'flex', 'important');
        offer.style.setProperty('align-items', 'center', 'important');
        offer.style.setProperty('justify-content', 'flex-start', 'important');
        offer.style.setProperty('position', 'absolute', 'important');
        offer.style.setProperty('inset', '0', 'important');
        offer.style.setProperty('width', '100%', 'important');

        offer.style.setProperty('background', 'transparent', 'important');
        offer.style.setProperty('border', 'none', 'important');
        offer.style.setProperty('border-radius', '0', 'important');
        offer.style.setProperty('box-shadow', 'none', 'important');
        offer.style.setProperty('padding', '0', 'important');

        offer.style.setProperty(
          'color',
          COLORS[index % COLORS.length],
          'important'
        );

        offer.style.setProperty('font-family', 'inherit', 'important');
        offer.style.setProperty('font-weight', '700', 'important');
        offer.style.setProperty('font-size', '13px', 'important');
        offer.style.setProperty('line-height', '1.3', 'important');
        offer.style.setProperty('white-space', 'nowrap', 'important');
        offer.style.setProperty('text-align', 'left', 'important');

        offer.style.setProperty(
          'opacity',
          index === 0 ? '1' : '0',
          'important'
        );

        offer.style.setProperty(
          'visibility',
          index === 0 ? 'visible' : 'hidden',
          'important'
        );

        offer.style.setProperty(
          'transform',
          index === 0 ? 'translateY(0)' : 'translateY(100%)',
          'important'
        );

        offer.style.setProperty('transition', 'none', 'important');
      });

      if (offers.length < 2) return;

      let current = 0;

      const timer = setInterval(() => {
        if (!container.isConnected) {
          clearInterval(timer);
          return;
        }

        const previous = offers[current];
        current = (current + 1) % offers.length;
        const next = offers[current];

        next.style.setProperty('transition', 'none', 'important');
        next.style.setProperty('visibility', 'visible', 'important');
        next.style.setProperty('opacity', '0', 'important');
        next.style.setProperty('transform', 'translateY(100%)', 'important');

        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            const transition =
              `transform ${DURATION}ms ease, opacity ${DURATION}ms ease`;

            previous.style.setProperty('transition', transition, 'important');
            next.style.setProperty('transition', transition, 'important');

            previous.style.setProperty('transform', 'translateY(-100%)', 'important');
            previous.style.setProperty('opacity', '0', 'important');

            next.style.setProperty('transform', 'translateY(0)', 'important');
            next.style.setProperty('opacity', '1', 'important');

            setTimeout(() => {
              previous.style.setProperty('visibility', 'hidden', 'important');
              previous.style.setProperty('transition', 'none', 'important');
            }, DURATION + 50);
          });
        });
      }, INTERVAL);
    });
  }

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);

  if (document.readyState !== 'loading') init();
})();
